import Vue from 'vue'
import moment from 'moment';
import categorys from './utils/categorys.js';
import config from './apis/config.js'

function mapCategory(value, categoryName) {
  var category = _.find(categorys[categoryName], o => o.CategoryID == value);
  if (category != null) {
    return category;
  }
  return {};
}
Vue.filter('DateFormat', function (value, DateFormat) {
  return moment(value).format(DateFormat);
});
Vue.filter('CategoryTitle', function (value, categoryName) {
  var category = mapCategory(value, categoryName);
  var mapResult = category["CategoryTitle"];
  if (mapResult) {
    return mapResult;
  }
  return value;
});
Vue.filter('CategoryCode', function (value, categoryName) {
  var category = mapCategory(value, categoryName);
  var mapResult = category["CategoryCode"];
  if (mapResult) {
    return mapResult;
  }
  return value;
});
Vue.filter('mapTitle', function (value, categoryName, defaultResult) {
  var category = mapCategory(value, categoryName);
  var mapResult = category["CategoryTitle"];
  if (mapResult) {
    return mapResult;
  }
  return defaultResult || value;
});
//获取文件服务器
Vue.filter('ToImgUrl', function (value) {
  var url = config.getUrl("fileUrl", "");
  url = url.substring(0, url.length - 1);
  if (value.indexOf('/') == 0) {
    return url + value;
  }
  return value;
});
Vue.filter('DiffTime', function (value, end, unit) {
  let startDate = moment(value);
  let endDate = moment(end);
  let diffDate = endDate.diff(startDate);
  let dayS = 1000 * 60 * 60 * 24;

  let times = moment.utc(diffDate % (dayS)).format("HH:mm");
  let howDay = parseInt(diffDate / dayS);
  if (howDay > 0) {
    return howDay + "d " + times;
  } else {
    return times;
  }
});
Vue.filter('DiffWeek', function (value) {
  return moment(value).weekday();
});
Vue.filter('DurationTime', function (value) {
  let Hours = parseInt(value / 60);
  let minutes = value % 60;
  return `${Hours}h${minutes}m`
})



// WEBPACK FOOTER //
// ./src/filter.js